// Module
var code = "<svg fill=#000000 xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 32 32\" width=32px height=32px><path fill=none stroke=#000000 stroke-miterlimit=10 stroke-width=2 d=\"M3 17L16 4 29 17\"/><path fill=none stroke=#000000 stroke-miterlimit=10 stroke-width=2 d=\"M6 14L6 27 13 27 13 17 19 17 19 27 26 27 26 14\"/></svg>";
// Exports
module.exports = code;